import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useMutation } from 'react-query';
import { createObjectiveKPI } from '../../../api/objective/objectiveKPI.api';
import ObjectiveKPIForm from './ObjectiveKPIForm';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const CreateKPI = ({
  objective,
  onSubmitSuccess
}) => {
  const { t } = useTranslation();

  const [ open, setOpen ] = useState(false);

  const form = useForm();

  const createMutation = useMutation(
    async values => {
      await createObjectiveKPI({
        kpi: {
          objectiveId: objective.id,
          ...values
        },
        objectiveId: objective.id,
        ownerId: objective.owner[0].id,
        ownerType: objective.owner[0].type
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess?.();
        setOpen(false);
        form.reset();
      }
    }
  );

  return <FormProvider { ...form }>
    <Button
      onClick={ () => setOpen(true) }
      variant='contained'
      color='secondary'
      style={ { marginTop: 16 } }
    >
      {t('objective.kpi.actions.create')}
    </Button>
    <Dialog
      open={ open }
      onClose={ () => setOpen(false) }
      PaperProps={ {
        component: 'form',
        onSubmit: form.handleSubmit(createMutation.mutate)
      } }
    >
      <DialogTitle>
        {t('objective.kpi.title.create')}
      </DialogTitle>
      <DialogContent>
        <ObjectiveKPIForm />
      </DialogContent>
      <DialogActions>
        <Button type='submit' color='primary' variant='contained'>
          { t('objective.dialog.save') }
        </Button>
        <Button onClick={ () => setOpen(false) } color='primary'>
          { t('objective.dialog.cancel') }
        </Button>
      </DialogActions>
    </Dialog>
  </FormProvider>;
};

export default CreateKPI;
